module.exports = __webpack_public_path__ + "static/media/5-5.27a5c073.mp3";